"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Anchor = /*#__PURE__*/function () {
  function Anchor(anchor) {
    _classCallCheck(this, Anchor);

    this.linkto = anchor.dataset.linkto;
    this.anchor = anchor;
    this.listen();
  }

  _createClass(Anchor, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.anchor.addEventListener("click", function () {
        _this.smoothScroll(_this.linkto);
      });
    }
  }, {
    key: "currentYPosition",
    value: function currentYPosition() {
      return window.scrollY;
    }
  }, {
    key: "elmYPosition",
    value: function elmYPosition(elemID) {
      // let headerHeight = document.querySelector('.header').clientHeight;
      var elm = document.getElementById("".concat(elemID, "-anchor"));
      var y = elm.offsetTop;
      var node = elm;

      while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      }

      return y;
    }
  }, {
    key: "smoothScroll",
    value: function smoothScroll(elemID) {
      var startY = this.currentYPosition();
      var stopY = this.elmYPosition(elemID);
      var distance = stopY > startY ? stopY - startY : startY - stopY;

      if (distance < 100) {
        scrollTo(0, stopY);
        return;
      }

      var speed = Math.round(distance / 100);
      if (speed >= 20) speed = 20;
      var step = Math.round(distance / 25);
      var leapY = stopY > startY ? startY + step : startY - step;
      var timer = 0;

      if (stopY > startY) {
        //scroll vers le bas
        for (var i = startY; i < stopY; i += step) {
          setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
          leapY += step;
          if (leapY > stopY) leapY = stopY;
          timer++;
        }

        return;
      } else {
        //scroll vers le haut
        for (var _i = startY; _i > stopY; _i -= step) {
          setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
          leapY -= step;
          if (leapY < stopY) leapY = stopY;
          timer++;
        }
      }
    }
  }]);

  return Anchor;
}();

document.addEventListener("DOMContentLoaded", function () {
  var anchors = _toConsumableArray(document.getElementsByClassName("js-anchor"));

  anchors.forEach(function (anchor) {
    new Anchor(anchor);
  });
});